import { useContext, useEffect, useRef } from 'react';
import { Context as CollectionContext } from './contexts/collection';
import { Context as MapContext } from './contexts/map';
export { useMapLoader } from './hooks/useMapLoader';
export { useMapUtil } from './hooks/useMapUtil';
export var useEvent = function (emitter, event, callback) {
    useEffect(function () {
        if (emitter && callback) {
            emitter.events.add(event, callback);
            return function () {
                emitter.events.remove(event, callback);
            };
        }
    }, [callback, emitter, event]);
};
export var useEvents = function (emitter, events) {
    useEffect(function () {
        if (!emitter || !events) {
            return;
        }
        Object.entries(events).forEach(function (_a) {
            var event = _a[0], callback = _a[1];
            emitter.events.add(event, callback);
        });
        return function () {
            Object.entries(events).forEach(function (_a) {
                var event = _a[0], callback = _a[1];
                emitter.events.remove(event, callback);
            });
        };
    }, [events, emitter]);
};
export var useCollection = function (geoObject) {
    var collection = useContext(CollectionContext);
    if (process.env.NODE_ENV !== 'production' && !collection) {
        throw new Error('Компонент необходимо обернуть в провайдер <Collection>');
    }
    useEffect(function () {
        if (geoObject) {
            collection.add(geoObject);
            return function () {
                collection.remove(geoObject);
            };
        }
    }, [collection, geoObject]);
};
export var useGeoObjectCoords = function (geoObject, coords) {
    // обновляем coords
    useEffect(function () {
        if (geoObject) {
            geoObject.geometry.setCoordinates(coords);
        }
    }, [coords, geoObject]);
};
export var useGeoObjectOptions = function (geoObject, options) {
    // обновляем options
    useEffect(function () {
        if (geoObject && options) {
            geoObject.options.set(options);
        }
    }, [options, geoObject]);
};
export var useGeoObjectProperties = function (geoObject, props) {
    // обновляем properties
    useEffect(function () {
        if (geoObject && props) {
            geoObject.properties.set(props);
        }
    }, [geoObject, props]);
};
export var useMapContext = function () {
    var map = useContext(MapContext);
    if (process.env.NODE_ENV !== 'production' && !map) {
        throw new Error('Компонент необходимо обернуть в провайдер <Map>');
    }
    return map;
};
export var useMapEvent = function (event, callback) {
    var map = useMapContext();
    useEvent(map, event, callback);
};
export var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
